import React, { useState, useEffect } from 'react'
import { Button, Paper, TextField, Typography } from "@material-ui/core";
import FileBase64 from "react-file-base64";
import { useDispatch, useSelector } from "react-redux";
import { newPost, deletePost, updatePost } from "./../redux/actions/post";
import DeleteIcon from '@material-ui/icons/Delete';

const PostForm = ({ currentId, setCurrentId }) => {
    const user = JSON.parse(localStorage.getItem("profile"));
    const dispatch = useDispatch();
    const posts = useSelector(state => state.posts);
    const [post, setPost] = useState({ title: "", message: "", tags: "", selectedFile: "" });

    const clear = () => setPost({ title: "", message: "", tags: "", selectedFile: "" });
    const handleChange = (e) => setPost({ ...post, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();

        if (post?.selectedFile?.substring(5, 10) !== "image" || post?.title?.length < 1 || post?.message?.length < 1) {
            alert("Error occured !");
            return false;
        }

        if (currentId) {
            dispatch(updatePost(currentId, { ...post, name: user?.user?.name }));
        }
        else {
            dispatch(newPost(post));
        }

        clear();
        setCurrentId(null);
    }

    const handleDelete = () => {
        dispatch(deletePost(currentId));
        clear();
        setCurrentId(null);
    }

    useEffect(() => setPost(posts.find(p => p._id === currentId)), [currentId]);

    if (!user) {
        return (
            <Paper elevation={3}>
                <Typography variant="h6" align="center">
                    Please Sign In to create your own posts and like others'.
                </Typography>
            </Paper>
        );
    }

    return (
        <div>
            <Paper elevation={3}>
                <div style={{ padding: "15px" }}>
                    <div>
                        <TextField required={true} name="title" variant="outlined" label="Title" fullWidth onChange={handleChange}
                            value={post?.title} style={{ marginBottom: "12px" }} />

                        <TextField required={true} name="message" variant="outlined" label="Message" fullWidth
                            multiline rows={4} value={post?.message} onChange={handleChange} style={{ marginBottom: "12px" }} />

                        <TextField required={true} name="tags" variant="outlined" label="Tags ( comma separated )" fullWidth
                            onChange={e => setPost({ ...post, tags: e.target.value.split(',') })}
                            value={post?.tags} style={{ marginBottom: "12px" }} />

                        <FileBase64 type="file" multiple={false} onDone={({ base64 }) => setPost({ ...post, selectedFile: base64 })} />

                        <Button style={{ marginTop: "12px" }} onClick={handleSubmit} fullWidth variant="contained" color="primary"
                            size="large">{currentId ? "Save Changes" : "Post"}
                        </Button>

                        <Button style={{ marginTop: "12px" }} onClick={() => {
                            clear();
                            setCurrentId(null);
                        }} fullWidth variant="contained" color="inherit" size="small">Clear
                        </Button>

                        {currentId && (
                            <Button style={{ marginTop: "12px" }} onClick={handleDelete} variant="contained"
                                fullWidth color="secondary" size="small"><DeleteIcon fontSize="small" /> Delete Post
                            </Button>
                        )}
                    </div>
                </div>
            </Paper>
        </div>
    )
}

export default PostForm;